// Star atom — infinite-loop lottie at a specified speed + direction.

import lottie from 'imports/lottie-web'

const star = {
    init() {
        document.querySelectorAll('[data-star]').forEach((el) => {
            if (el._lottie) return
            const src = el.dataset.lottieSrc
            if (!src) return

            const speed = parseFloat(el.dataset.speed || '1')
            const direction = parseInt(el.dataset.direction || '1', 10)

            const instance = lottie.loadAnimation({
                container: el,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: src,
            })
            instance.setSpeed(speed)
            instance.setDirection(direction)
            el._lottie = instance
        })
    }
}

export default star
